import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, signal, WritableSignal } from '@angular/core'
import { TuiInputDateRangeModule, TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy'
import { FormsModule } from '@angular/forms'
import { TuiCalendar } from '@taiga-ui/core'
import { TuiAutoFocus, TuiDay, TuiDayRange } from '@taiga-ui/cdk'
import { DatePipe } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'

@UseLocales({ ru, en })
@Component({
	selector: 'app-post-trading-filter',
	templateUrl: './post-trading-filter.component.html',
	styleUrl: './post-trading-filter.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TuiInputDateRangeModule,
		TuiInputModule,
		TuiTextfieldControllerModule,
		FormsModule,
		TuiAutoFocus,
		TuiCalendar,
		DatePipe,
		TranslatePipe,
		ButtonComponent,
		ClickOutsideDirective,
	],
})
export class PostTradingFilterComponent implements OnInit {
	protected readonly tuiDayRange: typeof TuiDayRange = TuiDayRange
	protected readonly tuiDay: typeof TuiDay = TuiDay

	@Output() searchTicker: EventEmitter<string> = new EventEmitter()
	@Output() datesRange: EventEmitter<TuiDayRange | null> = new EventEmitter()

	protected searchValue: WritableSignal<string> = signal('')
	protected isOpenCalendar: WritableSignal<boolean> = signal(false)
	protected currentDatesRange: WritableSignal<TuiDayRange | null> = signal(null)

	private _initDatesRange(): void {
		const today: TuiDay = this.tuiDay.currentLocal()
		const from: TuiDay = today.append({ day: -10 })

		this.currentDatesRange.set(new this.tuiDayRange(from, today))
		this.datesRange.emit(this.currentDatesRange())
	}

	protected toggleCalendar(value: boolean): void {
		this.isOpenCalendar.set(value)
	}

	protected onInputSearch(): void {
		this.searchTicker.emit(this.searchValue())
	}

	protected onDayClick(day: TuiDay): void {
		const datesRange: TuiDayRange | null = this.currentDatesRange()
		if (!datesRange) return

		if (!this.currentDatesRange()?.isSingleDay) {
			this.currentDatesRange.set(new this.tuiDayRange(day, day))
			this.datesRange.emit(this.currentDatesRange())
			return
		}

		this.currentDatesRange.set(this.tuiDayRange.sort(datesRange.from, day))
		this.datesRange.emit(this.currentDatesRange())
	}

	ngOnInit(): void {
		this._initDatesRange()
	}
}
